.container {
  position: relative;
  cursor: pointer;
  display: inline-block;
  color: var(--dds-color-icon-medium);
  background-color: transparent;
  border-radius: var(--dds-border-radius-button);

  @media (prefers-reduced-motion: no-preference) {
    transition:
      var(--dds-motion-micro-state) color,
      var(--dds-motion-micro-state) background-color,
      var(--dds-motion-micro-state) transform,
      var(--dds-focus-transition);
  }

  &:hover {
    color: var(--dds-color-icon-action-hover);
    background-color: var(--dds-color-surface-hover-default);
  }

  &:has(input:checked) {
    color: var(--dds-color-icon-action-resting);
  }

  &:hover:has(input:checked) {
    color: var(--dds-color-icon-action-hover);
  }

  &:active {
    .icon {
      transform: scale(0.75);
    }
  }
}

.container--medium {
  width: var(--dds-size-icon-medium);
  height: var(--dds-size-icon-medium);
}

.container--large {
  width: var(--dds-size-icon-large);
  height: var(--dds-size-icon-large);
}

.icon {
  color: currentColor;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 1;
  @media (prefers-reduced-motion: no-preference) {
    transition:
      opacity var(--dds-motion-micro-state),
      transform var(--dds-motion-micro-state);
  }
}

.icon--invisible {
  opacity: 0;
}
